var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedArabEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.873C24.8366 32.873 32 25.7096 32 16.873C32 8.03649 24.8366 0.873047 16 0.873047C7.16344 0.873047 0 8.03649 0 16.873C0 25.7096 7.16344 32.873 16 32.873Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04419 22.4383L10.4355 31.878C12.1688 32.5212 14.0436 32.8731 16.0007 32.8731C22.8801 32.8731 28.7448 28.5311 31.0054 22.4383H9.04419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04419 11.3079L10.4355 1.86811C12.1688 1.22492 14.0436 0.873047 16.0007 0.873047C22.8801 0.873047 28.7448 5.21505 31.0054 11.3079H9.04419Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8732C0 23.7526 4.34206 29.6173 10.4348 31.878V1.86837C4.34206 4.12906 0 9.99375 0 16.8732Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.873047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedArabEmirates);
export default __webpack_public_path__ + "static/media/united-arab-emirates.e3430790.svg";
export { ForwardRef as ReactComponent };